import Skeleton from "react-loading-skeleton";

const MapPropertyPopupCardSkeleton = () => {
  return (
    <>
      <div className="w-[246px] h-[238px] bg-white rounded-[10px] overflow-hidden">
        <div className="w-full h-[121px]">
          <Skeleton height="100%" width="100%" />
        </div>
        <div className="px-[13px] pb-[11px] mt-[6px] w-full">
          <Skeleton height={30} width="50%" />
          <div className="flex flex-row items-center space-x-[24px] mt-[6px] h-5">
            <Skeleton height={20} width={50} />
            <Skeleton height={20} width={50} />
            <Skeleton height={20} width={50} />
          </div>
          <div className="grid grid-cols-4 flex-row items-center h-[30px] mt-[9px] w-full gap-3">
            <Skeleton width="100%" height={30} />
            <Skeleton width="100%" height={30} />
            <Skeleton width="100%" height={30} />
            <Skeleton width="100%" height={30} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MapPropertyPopupCardSkeleton;
